import { Component, Input } from '@angular/core';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { UserService } from '../../services/user/user.service';

@Component({
	selector: 'pcm-timesheet-expenses',
	templateUrl: './timesheet-expenses.component.html',
	styleUrls: ['./timesheet-expenses.component.scss']
})
export class TimesheetExpensesComponent {

	@Input() correctExpenses = false;
	@Input() removeFile: any;
	constructor(
		public timesheetService: TimesheetService,
		public dataService: DataService,
		public configService: ConfigService,
		private userService: UserService
	) { }

	canExpense() {
		let canExpense = true;

		const timesheetFields = this.configService.getDataObj(this.configService.timesheetDataObj).fields;
		const canEditExpenses = this.configService.canDo(timesheetFields, this.configService.timeentryProp, 'edit');

		const timeSubmitted = this.dataService.getTimesheetStatus() === this.configService.timesheetSubmitStatus;
		const timeSaved = this.dataService.getTimesheetStatus() === this.configService.timesheetSaveStatus;
		const isLocked = this.dataService.getTimeLock();
		const isRejected = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetRejectedStatus;

		if (isLocked || !canEditExpenses || timeSubmitted || isRejected) {
			canExpense = false;
		}

		if (this.correctExpenses && canEditExpenses && timeSaved && !isRejected) {
			canExpense = true;
		}

		if (!this.dataService.contractorDetails.ilcenabled && this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			canExpense = false;
		}

		return canExpense;

	}

	canUploadFile() {

		let canUpload = true;

		const docProp = this.configService.timesheetDocsProp;

		const canDo = this.configService.canDo(this.configService.getDataObj(this.configService.timesheetDataObj).fields, docProp, 'edit');

		const submitted = this.dataService.getTimesheetStatus() === this.configService.timesheetSubmitStatus;
		const timeSaved = this.dataService.getTimesheetStatus() === this.configService.timesheetSaveStatus;
		const isLocked = this.dataService.getTimeLock();
		const isRejected = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetRejectedStatus;

		if (this.correctExpenses) {
			canUpload = canDo && timeSaved && !isRejected;
		} else {
			canUpload = canDo && !submitted && !isLocked && !isRejected;
		}

		if (!this.dataService.contractorDetails.ilcenabled && this.userService.isContractor() && this.dataService.isTimesheetHoursLock()) {
			canUpload = false;
		}
		return canUpload;
	}

	onUpload(file, type) {
		this.timesheetService.recUpload(type, file);
	}
}
